// The `*Summary` strips → SummaryTiles values: a declaration figure with its working one beside it.
import { formatQuantityOrDash, formatSecondaryQuantities } from '@/lib/format/number';
import { unitSymbol } from '@/lib/mappers/units';

// "1,000 mt (1,100 m³)" — a missing amount stays a dash rather than becoming 0.
const buildTile = (dto) => {
  const declarationUnit = unitSymbol(dto?.declarationUnit);
  const workingUnit = unitSymbol(dto?.workingUnit);
  return (declarationAmount, workingAmount) =>
    [
      formatQuantityOrDash(declarationAmount, declarationUnit),
      formatSecondaryQuantities([[workingAmount, workingUnit]]),
    ]
      .filter(Boolean)
      .join(' ');
};

export const processContractsStrip = (dto) => {
  const tile = buildTile(dto);
  return {
    contracted: tile(dto?.totalContractedQuantityDeclaration, dto?.totalContractedQuantityWorking),
    shipped: tile(dto?.totalShippedQuantityDeclaration, dto?.totalShippedQuantityWorking),
    outstanding: tile(
      dto?.totalOutstandingQuantityDeclaration,
      dto?.totalOutstandingQuantityWorking,
    ),
  };
};

export const processShipmentsStrip = (dto) => {
  const tile = buildTile(dto);
  return {
    shipment: tile(dto?.totalShipmentQuantityDeclaration, dto?.totalShipmentQuantityWorking),
    received: tile(
      dto?.totalReceivedDeclarationQuantityDeclaration,
      dto?.totalReceivedDeclarationQuantityWorking,
    ),
    pending: tile(
      dto?.totalPendingShipmentQuantityDeclaration,
      dto?.totalPendingShipmentQuantityWorking,
    ),
    available: tile(
      dto?.totalAvailableShipmentQuantityDeclaration,
      dto?.totalAvailableShipmentQuantityWorking,
    ),
  };
};

export const processDeclarationsStrip = (dto) => {
  const tile = buildTile(dto);
  return {
    received: tile(dto?.totalReceivedQuantityDeclaration, dto?.totalReceivedQuantityWorking),
    adjusted: tile(dto?.totalAdjustedQuantityDeclaration, dto?.totalAdjustedQuantityWorking),
    available: tile(dto?.totalAvailableQuantityDeclaration, dto?.totalAvailableQuantityWorking),
  };
};

export const processOrdersStrip = (dto) => {
  const tile = buildTile(dto);
  return {
    contracted: tile(dto?.totalContractedQuantityDeclaration, dto?.totalContractedQuantityWorking),
    shipped: tile(dto?.totalShippedQuantityDeclaration, dto?.totalShippedQuantityWorking),
    allocated: tile(dto?.totalAllocatedQuantityDeclaration, dto?.totalAllocatedQuantityWorking),
    remainingToAllocate: tile(
      dto?.totalRemainingToAllocateQuantityDeclaration,
      dto?.totalRemainingToAllocateQuantityWorking,
    ),
  };
};

export const processOutgoingShipmentsStrip = (dto) => {
  const tile = buildTile(dto);
  return {
    shipment: tile(dto?.totalShipmentQuantityDeclaration, dto?.totalShipmentQuantityWorking),
    allocated: tile(dto?.totalAllocatedQuantityDeclaration, dto?.totalAllocatedQuantityWorking),
    remainingToAllocate: tile(
      dto?.totalRemainingToAllocateQuantityDeclaration,
      dto?.totalRemainingToAllocateQuantityWorking,
    ),
  };
};

export const processAllocationsStrip = (dto) => ({
  allocated: buildTile(dto)(
    dto?.totalAllocatedQuantityDeclaration,
    dto?.totalAllocatedQuantityWorking,
  ),
});
